import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/queryKeys'

interface Version {
  sha: string
  env: string
  builtAt: string
}

/** Build stamp from /version.json (written at build time); shown in the account popover. */
export function useVersion() {
  return useQuery({
    queryKey: queryKeys.version,
    queryFn: async ({ signal }) => {
      const res = await fetch('/version.json', { signal })
      if (!res.ok) throw new Error('version.json unavailable')
      return (await res.json()) as Version
    },
    staleTime: Infinity,
    retry: false,
  })
}
